import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { appConfig } from "./site-config";
import { initData } from "@telegram-apps/sdk-react";
import { parseStartAppString } from "@/shared/utils";

export const useFetch = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  // headers: {
  //   "Content-Type": "application/json",
  // "Access-Control-Allow-Origin": "*",
  // }
});

// Request interceptor to attach the access token to each request
useFetch.interceptors.request.use((config) => {
  const locale = localStorage.getItem("locale");
  config.headers["Accept-Language"] = locale || "uz";

  const parseStartApp = parseStartAppString(initData.startParam());
  config.headers["X-Referral-Code"] = parseStartApp?.ref || undefined;

  if (!config.headers["Authorization"]) {
    config.headers["Authorization"] = `tma ${initData.raw()}`;
  }
  return config;
});

interface RefreshTokenResponse {
  access: string;
  refresh: string;
}

const refreshAuthLogic = async (failedRequest: any) => {
  try {
    // await apiClient.refreshToken(undefined);
    const refreshToken = sessionStorage.getItem(
      appConfig.secret.refreshTokenKey
    );
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }
    const res = await axios.post<RefreshTokenResponse>(
      `${import.meta.env.VITE_API_BASE_URL}users/RefreshToken`,
      { refresh: refreshToken }
    );
    const { access, refresh } = res.data;
    sessionStorage.setItem(appConfig.secret.accessTokenKey, access);
    sessionStorage.setItem(appConfig.secret.refreshTokenKey, refresh);

    // Set the new token in the headers for the failed request
    failedRequest.response.config.headers["Authorization"] = `Bearer ${access}`;

    return Promise.resolve();
  } catch (error) {
    // Handle refresh token failure (e.g., logout user)
    sessionStorage.removeItem(appConfig.secret.accessTokenKey);
    sessionStorage.removeItem(appConfig.secret.refreshTokenKey);
    console.error("Token refresh failed", error);
    window.location.reload();
    return Promise.reject(error);
  }
};

createAuthRefreshInterceptor(useFetch, refreshAuthLogic);

export default { useFetch };
